import { Preferences  } from '@capacitor/preferences';
import { Injectable } from "@angular/core";

// const { Storage } = Plugins;

@Injectable()
export class StorageService {

    constructor() {
        this.migrateStorage(); 
    }

    async migrateStorage() {
        try {
            await Preferences .migrate();
            console.log('Storage migration successful');
        } catch (error) {
            console.error('Storage migration failed', error);
        }
    }

    remove(key: string): Promise<any> {
        return Preferences .remove({ key: key });
    }
    set(key: string, val: any): Promise<any> {
        return new Promise<any>(response => {
            if (val instanceof Object) {
                val = JSON.stringify(val);
            }
            Preferences .set({ key: key, value: val }).then(r => {
                return response(val);
            });
        });
    }
    get(arg1: string): Promise<any> {
        return new Promise<any>(response => {
            Preferences .get({ key: arg1 }).then( r => {
                if (!r.value) {
                    return response(r.value);
                }
                if (r.value.includes('[') || r.value.includes('[{') || r.value.includes('{')) {
                    return response(JSON.parse(r.value));
                }
                return response(r.value);
            });
        });
    }
}